import { render, staticRenderFns } from "./NativeSelect.vue?vue&type=template&id=28e5b799&scoped=true"
import script from "./NativeSelect.vue?vue&type=script&lang=js"
export * from "./NativeSelect.vue?vue&type=script&lang=js"
import style0 from "./NativeSelect.vue?vue&type=style&index=0&id=28e5b799&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5b799",
  null
  
)

export default component.exports